function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Layer_3"
});

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Layer_1"
}, /*#__PURE__*/React.createElement("path", {
  className: "svg-fill-amber",
  d: "M9.19,8.87c0-1.55,1.26-2.81,2.81-2.81s2.81,1.26,2.81,2.81s-1.26,2.81-2.81,2.81S9.19,10.42,9.19,8.87z  M21.96,18.54c0,3.38-8.94,3.48-9.96,3.48s-9.96-0.1-9.96-3.48c0-2.13,3.7-2.95,6.29-3.26c-2.1-2.69-3.17-4.84-3.17-6.41 c0-3.78,3.07-6.85,6.84-6.85c3.77,0,6.84,3.07,6.84,6.85c0,1.56-1.07,3.72-3.17,6.41C18.26,15.59,21.96,16.41,21.96,18.54z  M7.16,8.87c0,1.29,1.42,3.69,3.88,6.58c0,0,0,0,0,0c0.17,0.19,0.32,0.37,0.47,0.53c0.17,0.19,0.34,0.37,0.48,0.53 c0.27-0.29,0.6-0.65,0.96-1.06c2.47-2.88,3.88-5.29,3.88-6.58c0-2.67-2.17-4.85-4.84-4.85S7.16,6.2,7.16,8.87z M19.89,18.54 c-0.46-0.44-2.38-1.17-5.76-1.4c-0.04,0.05-0.08,0.09-0.12,0.14c-0.12,0.13-0.23,0.26-0.34,0.38c-0.06,0.06-0.11,0.12-0.16,0.18 c-0.12,0.13-0.23,0.25-0.33,0.35c-0.04,0.04-0.07,0.08-0.11,0.12c-0.09,0.1-0.17,0.17-0.22,0.23c-0.03,0.03-0.03,0.03-0.05,0.05 c-0.05,0.05-0.08,0.08-0.09,0.09c-0.19,0.19-0.44,0.3-0.71,0.3s-0.52-0.11-0.71-0.3c-0.01-0.01-0.17-0.17-0.41-0.42 c-0.01-0.01-0.01-0.01-0.02-0.02c-0.11-0.12-0.25-0.26-0.4-0.43c-0.03-0.03-0.06-0.06-0.09-0.1c-0.15-0.16-0.31-0.34-0.48-0.53 c-0.01-0.01-0.02-0.02-0.03-0.03c-3.38,0.24-5.3,0.97-5.76,1.4c0.59,0.58,3.46,1.48,7.9,1.48S19.3,19.12,19.89,18.54z"
}));

var SvgIconPort = function SvgIconPort(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconPort, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon_port.5b3ddc3f.svg";
export { ForwardRef as ReactComponent };